var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":_vm.graphql,"update":_vm.getEntries},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',[_vm._v("Loading...")]):(error)?_c('div',[_vm._v("An error occured")]):(data)?_c('ul',_vm._l((data),function(entry){
var _obj;
return _c('li',{key:entry,class:( _obj = { active: _vm.isActive(entry) }, _obj[("color-" + _vm.variant)] = true, _obj ),on:{"click":function($event){!_vm.isActive(entry) && _vm.$router.push((_vm.baseURL + "/" + entry))}}},[_vm._v("\n        "+_vm._s(entry)+"\n      ")])}),0):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }